import axios from "axios";
import React, { useEffect, useState } from "react";
import { PRIVACY_POLICY_URL } from "variables/constants";


const PrivacyPolicy = (props) => {
    const [html, setHTML] = useState("");

    useEffect(() => {
        fetchPrivacyPolicy()
    }, []);

    const fetchPrivacyPolicy = async () => {
        let promise = await axios.get(PRIVACY_POLICY_URL);
        setHTML(promise.data);
    }
    
    return (<>
        <div dangerouslySetInnerHTML={{__html: html}}></div>
    </>);
};

export default PrivacyPolicy;
